import { render } from "./BackToTopButton.vue?vue&type=template&id=b0ced5d0"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"

import "./BackToTopButton.vue?vue&type=style&index=0&id=b0ced5d0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__